import { render, staticRenderFns } from "./ActivityDetailNew.vue?vue&type=template&id=7efa7dec&scoped=true&"
import script from "./ActivityDetailNew.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efa7dec",
  null
  
)

export default component.exports